import Tooltip from 'modules/shared-components/tooltip';
import Big from 'big.js';
import { formatNumberWithSuffix } from 'utils/FormatNumber';
import { ContractInfo } from 'api/types/httpsTypes/contracts';
import { EthAddress } from 'modules/ethereum/components/EthAddress';
import { isNotNil } from 'modules/utils/isNotNil';
import { ListItem, ListItemLabel, ListItemValue } from './tradingInfo';

interface Props {
  contract: ContractInfo;
}

export const OwnerInfo = ({ contract }: Props) => {
  return (
    <div className="xxs:dark:bg-dex-black-700 xxs:p-2 xxs:rounded w-full xxs:space-y-1">
      <div className="hidden lg:block font-bold text-sm">Owner Info</div>
      <ul className="flex flex-col xxs:space-y-1 p-0">
        <ListItem>
          <ListItemLabel>
            <Tooltip text="The address of the contract owner.">
              <div className="xxs:text-dex-white-secondary hover:text-dex-white">
                Owner Address
              </div>
            </Tooltip>
          </ListItemLabel>
          <ListItemValue>
            <span className="font-bold">
              {contract.ownerInfo.ownerAddress ? (
                <EthAddress
                  address={contract.ownerInfo.ownerAddress}
                  chain={contract.generalInfo.chain.key}
                  kind="account"
                />
              ) : (
                '--'
              )}
            </span>
          </ListItemValue>
        </ListItem>
        <ListItem>
          <ListItemLabel>
            <Tooltip text="The amount of tokens owned by the contract owner.">
              <div className="xxs:text-dex-white-secondary hover:text-dex-white">
                Owner Balance
              </div>
            </Tooltip>
          </ListItemLabel>
          <ListItemValue>
            {contract.ownerInfo.ownerBalance &&
            isNotNil(contract.ownerInfo.ownerPercent) ? (
              <span
                className={
                  Big(contract.ownerInfo.ownerPercent).gte(0.1)
                    ? 'text-red-500 font-bold'
                    : 'font-bold'
                }
              >
                {formatNumberWithSuffix(contract.ownerInfo.ownerBalance, {
                  precision: 1,
                })}{' '}
                {contract.generalInfo.symbol} (
                {Big(contract.ownerInfo.ownerPercent).times(100).toFixed(0)}
                %)
              </span>
            ) : (
              <span className="font-bold">--</span>
            )}
          </ListItemValue>
        </ListItem>
        <ListItem>
          <ListItemLabel>
            <Tooltip text="The address of the contract creator.">
              <div className="xxs:text-dex-white-secondary hover:text-dex-white">
                Creator Address
              </div>
            </Tooltip>
          </ListItemLabel>
          <ListItemValue>
            <span className="font-bold">
              {contract.ownerInfo.creatorAddress ? (
                <EthAddress
                  kind="account"
                  chain={contract.generalInfo.chain.key}
                  address={contract.ownerInfo.creatorAddress}
                />
              ) : (
                <span>--</span>
              )}
            </span>
          </ListItemValue>
        </ListItem>
        <ListItem>
          <ListItemLabel>
            <Tooltip text="The amount of tokens owned by the contract creator.">
              <div className="xxs:text-dex-white-secondary hover:text-dex-white">
                Creator Balance
              </div>
            </Tooltip>
          </ListItemLabel>
          <ListItemValue>
            {contract.ownerInfo.creatorBalance &&
            isNotNil(contract.ownerInfo.creatorPercent) ? (
              <span
                className={
                  Big(contract.ownerInfo.creatorPercent).gte(0.1)
                    ? 'text-red-500 font-bold'
                    : 'font-bold'
                }
              >
                {formatNumberWithSuffix(contract.ownerInfo.creatorBalance, {
                  precision: 1,
                })}{' '}
                {contract.generalInfo.symbol} (
                {Big(contract.ownerInfo.creatorPercent).times(100).toFixed(0)}
                %)
              </span>
            ) : (
              <span className="font-bold">--</span>
            )}
          </ListItemValue>
        </ListItem>
      </ul>
    </div>
  );
};
